import { useState, useEffect } from "react";
import SelectFilter from "./Filters/SelectFilter";
import Search from "./icons/Search";
import Close from "./icons/Close";

import GalleryCards from "./GalleryCards";
import Hamburguer from "./icons/Hamburger";

function isEmpty(obj) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }
    return true;
}

export default function Gallery() {
    const [search, setSearch] = useState("");
    const [showMobileFilters, setshowMobileFilters] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [nfts, setNfts] = useState([]);
    const [itemsInPage, setItemsInPage] = useState(nfts.length);
    const [filters, setFilters] = useState({});



    const toggleFilter = (filterCategory, filterValue) => {
        if (!activeFilters[filterCategory]) {
            activeFilters[filterCategory] = [];
        }
        const index = activeFilters[filterCategory].findIndex(value => value === filterValue);
        if (index >= 0) {
            activeFilters[filterCategory].splice(index, 1);
        } else {
            activeFilters[filterCategory].push(filterValue);
        }
        filters[filterCategory][filterValue].check = !filters[filterCategory][filterValue].check;
        setFilters({ ...filters })
        setActiveFilters({
            ...activeFilters
        })
    };
    useEffect(() => {

        if (isEmpty(filters)) {
            for (const nft of nfts) {
                for (const attribute of nft.attributes) {
                    if (!filters[attribute.trait_type]) {
                        filters[attribute.trait_type] = [];
                        filters[attribute.trait_type][attribute.value] = {
                            qtd: 0,
                            check: false,
                            toggle: toggleFilter
                        };
                    } else if (!filters[attribute.trait_type][attribute.value]) {
                        filters[attribute.trait_type][attribute.value] = {
                            qtd: 0,
                            check: false,
                            toggle: toggleFilter
                        };
                    }
                    filters[attribute.trait_type][attribute.value].qtd += 1;
                }
            }
            setFilters(filters)
        }
    }, [nfts]);

    const filterBadges = [];
    for (const filterGroup in activeFilters) {
        if (activeFilters[filterGroup]) {
            for (const activeFilter of activeFilters[filterGroup]) {
                const removeFilter = () => {
                    const element = document.getElementById(`filter-${activeFilter}`);
                    element.classList.remove('animate-fadeIn');

                    element.classList.add('animate-fadeOut');
                    setTimeout(() => {
                        toggleFilter(filterGroup, activeFilter);

                    }, 100);
                };

                filterBadges.push(
                    <div className={`flex px-[10px] md:px-[0px] md:pr-[10px] py-[5px]`}>
                        <span
                            className="flex justify-between px-[10px] itens-center w-[140px] md:w-[120px] lg:w-[153px] ll:w-[164px] rounded-md cursor-pointer text-20 bg-purple-750 border-1 truncate animate-fadeIn"
                            key={activeFilter}
                            id={`filter-${activeFilter}`}
                            onClick={removeFilter}
                        >
                            <span className="pt-[3px] truncate">{activeFilter}</span>
                            <Close className="inline" />
                        </span>
                    </div>
                );
            }
        }
    }
    const clearFilters = () => {
        const activeCopy = {};
        for (const dale in activeFilters) {
            for (const dele of activeFilters[dale]) {
                if (!activeCopy[dale]) {
                    activeCopy[dale] = [];
                }
                activeCopy[dale].push(dele)
            }
        }
        for (const filterGroup in activeCopy) {
            for (const filter in activeCopy[filterGroup]) {
                toggleFilter(filterGroup, activeCopy[filterGroup][filter])
            }
        }
    }
    const handleInputChange = (event) => {
        setSearch(event.target.value);
    };
    const toggleMobileFilterVisibility = () => {
        // if (!showMobileFilters) {
        //     document.body.style.overflow = "hidden";
        // } else {
        //     document.body.style.overflow = "";
        // }
        setshowMobileFilters(!showMobileFilters)
    };

    useEffect(() => {
        if (nfts.length === 0) {
            const fetchNfts = async () => {
                try {
                    const response = await fetch(`${window.location.origin}/assets/nfts.json`);
                    const data = await response.json();
                    setNfts(data);
                } catch (error) {
                    console.error("Erro ao carregar NFTs:", error);
                }
            };
            fetchNfts();
        }
    }, [nfts]);

    return (
        <section className="flex flex-col md:flex-row sm:w-[408px] md:w-[840px] lg:w-[1070px] ll:w-[1270px] w-[340px] justify-stretch bg-gallery rounded-[30px]  md:rounded-[50px] md:mr-[30px] md:gap-[30px] gap-[13px] overflow-hidden">
            <div className="hidden md:flex flex-row md:w-[1280px] h-full md:gap-[30px] overflow-x-hidden">
                <div className="hidden md:flex flex-col mt-[30px] mb-[30px] ml-[30px] gap-[20px]">
                    <h2 className="flex h-[90px] w-[300px] justify-center items-center bg-darker rounded-[20px] text-60 text-center">Gallery</h2>
                    <aside className="flex flex-col justify-start w-full h-auto">
                        <div className="flex items-center w-full">
                            <p className="text-right text-32 ml-[6px]">Results: <span>?????</span>/<span>?????</span></p>
                        </div>
                        <div className="border-darker border-b-2 w-[300px] h-[2px]">
                        </div>
                        <div className="flex items-center w-full gap-[7px]">
                            <h3 className="text-right hidden ml-[6px] text-40 md:block">
                                Filters
                            </h3>
                        </div>
                        <div className={"flex flex-col gap-[12px]"}>
                            <SelectFilter />
                            <button className="bg-red-550 hover:bg-red-600 w-full h-[40px] rounded-[12px] text-2xl" onClick={clearFilters}>Clear Filters</button>
                        </div>
                    </aside>
                </div>

                <div className="hidden md:flex mt-[45px] sm:w-[450px] lg:w-[880px] mb-[35px] mr-[30px] min-h-[850px]">
                    <div className="flex flex-col justify-normal   w-full gap-[7px] overflow-x-hidden">

                        <div className="sticky top-0 flex md:justify-center lg:justify-start bg-purple-rosa z-12 ">
                            <div className="pb-[11.5px] w-full  " >
                                <div className={`relative flex items-center md:mr-[20px] lg:mr-[32px] ll:mr-[11px] ${filterBadges.length < 1 ? "pb-[20px]" : ""} `}>
                                    <Search className="absolute w-[28px] h-[28px] top-[11px] left-[15px]" />
                                    <input
                                        type="search"
                                        onChange={handleInputChange}
                                        className="w-full h-[50px] rounded-[20px] pl-12 pr-3 text-gray-600 text-32 outline-none"
                                    />
                                </div>
                                <div className={`flex flex-wrap items-center md:justify-center lg:justify-start w-full overflow-hidden transition-all duration-200 ease-in-out ${filterBadges.length < 1 ? "h-0" : "mt-[8px] pt-[11px] opacity-100 h-auto"}`}>
                                    {filterBadges}
                                </div>

                            </div>
                        </div>

                        <div className="flex w-full lg:justify-start ">
                            <div className={`md:w-[650px] ll:w-full ${filterBadges.length < 1 ? "h-[710px]" : "h-[770px]"} transition-all duration-100 ease-in-out`}>
                                <GalleryCards nfts={nfts} activeFilters={activeFilters} setCardsListed={setItemsInPage} search={search} />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <nav className="block md:hidden w-[340px] sm:w-[408px] justify-center items-center">
                <div className="flex flex-col w-[340px] sm:w-[408px] h-[40px] justify-center items-center mt-[35px] gap-[10px]">
                    <h2 className="flex w-[313px] sm:w-[375px] h-[40px] justify-center items-center bg-darker rounded-[10px] text-32 pt-[1px] text-center">Gallery</h2>
                    <div className="flex w-[313px] sm:w-[375px] h-[25px] justify-between items-center gap-[5px]">
                        <div className="relative w-[280px] sm:w-[336px]">
                            <Search className="absolute w-[16px] h-[15px] top-[5px] left-[7px]" />
                            <input type="number" onChange={handleInputChange} className="h-[25px] w-full rounded-[10px] outline-none pt-[1px] pl-[30px] pr-[4px] text-gray-600 text-lg" />
                        </div>
                        <div onClick={toggleMobileFilterVisibility}>
                            <Hamburguer />
                        </div>
                    </div>
                </div>
                <div className="mt-[25px]  flex flex-col w-full justify-center items-center">
                    <p className="text-center text-20 w-[313px] sm:w-[375px] mb-[5px]">Results: <span>?????</span>/<span>?????</span></p>
                    <div className="border-b-2 border-darker w-[313px] sm:w-[375px]"> </div>
                </div>

                <div className={`flex flex-col fixed bg-purple-rosa inset-0 z-[9999] transition-transform duration-500 ${showMobileFilters ? "translate-y-0" : "-translate-y-full"}`}>
                    <span className="absolute top-0 cursor-pointer right-4 text-40 text-darker" onClick={toggleMobileFilterVisibility}>x</span>

                    <div className="flex items-center justify-center pt-6">
                        <span className="bg-darker w-[182px] sm:w-[218px] rounded-[10px]">
                            <h3 className="sticky top-0 z-10 flex text-40 h-[50px] items-center justify-center">
                                Filters
                            </h3>
                        </span>
                    </div>

                    <aside className="flex flex-col w-full h-full justify-around overflow-y-auto mt-[10px] mb-[20px]">
                        <div className="flex flex-col justify-start items-center gap-[16px] p-4">
                            <SelectFilter />
                            <button className="bg-red-550 hover:bg-red-600 h-[40px] w-[300px] rounded-[12px] text-2xl" onClick={clearFilters}>Clear Filters</button>
                            <button className="bg-purple-750 hover:purple-750 h-[40px] w-[300px] rounded-[12px] text-2xl" onClick={toggleMobileFilterVisibility}>Done</button>
                        </div>
                    </aside>
                </div>
            </nav>

            <div className="flex justify-center w-full md:hidden">
                <div className="block md:hidden flex-col justify-center w-[313px] sm:w-[375px] gap-[12px] mb-[6px] overflow-auto scroll-container">
                    <div className="flex flex-col w-full items-center overflow-x-hidden pl-[5px]">
                        <div className={`${filterBadges.length < 1 ? "hidden" : ""} flex w-[320px] sm:w-[384px] justify-center bg-purple-rosa sticky top-0 z-12`}>
                            <div className={`flex flex-wrap justify-start w-full mb-4`}>
                                {filterBadges}
                            </div>
                        </div>
                        <div className={`flex w-[340px] sm:w-[408px] mt-[6px] ${filterBadges.length < 1 ? "max-h-[513px]" : "max-h-[750px]"}`}>
                            <GalleryCards nfts={nfts} activeFilters={activeFilters} setCardsListed={setItemsInPage} search={search} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}